import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Card, CardImg, CardBody, CardText } from "reactstrap";
import compoundImg from "assets/images/bg.png";
import compoundLogo from "assets/images/compound.png";
import AuthCard from "components/Website/Cards/AuthCard";
import { useSelector, useDispatch } from "react-redux";
import { authenticate, addInterest } from "store/Auth/actions";
import developerdImg from "assets/images/developer_logo.png";
import { useTranslation } from "react-i18next";

function CompoundCard({ compound, deleteCompound, history, location }) {
	// const [modal, setModal] = useState(false)
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const checkAuth = () => {
		if (AuthData.token && AuthData.userType === "user") {
			history.push(`/compound-details/${compound.id}`);
		} else {
			dispatch(
				authenticate({ navigateTo: `/compound-details/${compound.id}` })
			);
			history.push(`/login`, {
				navigateTo: `/compound-details/${compound.id}`,
			});
		}
	};
	return (
		<div className="position-relative">
			<Card className="comCard mx-2" onClick={() => checkAuth()}>
				{compound?.images?.length > 0 ? (
					compound?.images?.map((img, index) => {
						if (index === 0) {
							return <CardImg key={index} src={img.path}></CardImg>;
						}
					})
				) : (
					<CardImg src={compoundImg}></CardImg>
				)}
				<div className="comp-details">
					<p className="text-white fw-bold">
						{compound?.name[`${AuthData.lang}`]
							? compound?.name[`${AuthData.lang}`]
							: compound?.name.en}
					</p>
				</div>
				{/* <CardBody className='bodyComapre'>
        {compound?.developer?.media?.path ? <img src={compound.developer.media.path} className='imgAbsolute' /> :
        <img src={developerdImg} className='imgAbsolute' />}
          <Row>
            <Col md={12}>
              <CardText tag='h4' className='font-size-14 fw-bold'>
                {compound ?.name[`${AuthData.lang}`] ? compound ?.name[`${AuthData.lang}`] :compound ?.name ?.en}
              </CardText>
            </Col>
          </Row>
          <CardText tag='h4' className='font-size-14 pt-3'>
          {compound ?.installment ? t("up to installment",{num:compound ?.installment})  :t("only cash")}
          </CardText>
          <Row className='pt-2'>
            <Col md={6}>
              <CardText tag='p' className='font-size-13 text-muted mb-1'>
              {t("starting from")} 
              </CardText>
              <CardText tag='h4' className='font-size-14'>
                 {toCurrency(compound?.starting_from)} {currency?.currency_code}
              </CardText>
            </Col>
            <Col md={6}>
              <CardText tag='p' className='font-size-13 text-muted mb-1'>
              {t("to")} 
              </CardText>
              <CardText tag='h4' className='font-size-14'>
                 {toCurrency(compound?.end_to)} {currency?.currency_code}
              </CardText>
            </Col>
          </Row>
        </CardBody> */}
			</Card>
			<button
				onClick={() => {
					deleteCompound(compound.id);
				}}
				className="btn mx-auto d-block btnPlus position-absolute comparison-button remove-comp">
				<i className="fa fa-times-circle"></i>
			</button>
		</div>
	);
}
const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default CompoundCard;
